import withIcon from './NewIcon';
// @ts-ignore
import IconMoreV from './icon/m/more-v.s.svg';

export default withIcon(IconMoreV);
